"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionResultStatus = void 0;
/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
var ActionResultStatus;
(function (ActionResultStatus) {
    ActionResultStatus["DONE"] = "DONE";
    ActionResultStatus["ARCHIVED"] = "ARCHIVED";
    ActionResultStatus["Done"] = "DONE";
    ActionResultStatus["Archived"] = "ARCHIVED";
})(ActionResultStatus || (exports.ActionResultStatus = ActionResultStatus = {}));
